const DB_NAME = "utoo";
const DB_VERSION = 1;

export const INDEXED_DB_TABLES = {
	categories: "categories",
	tags: "tags",
	cities: "cities",
	translations: "translations",
};

let dbPromise = null;

async function openDB() {
	if (!dbPromise) {
		dbPromise = new Promise((resolve, reject) => {
			const request = indexedDB.open(DB_NAME, DB_VERSION);

			request.onerror = () => reject(request.error);
			request.onsuccess = () => resolve(request.result);

			request.onupgradeneeded = (event) => {
				const db = event.target.result;
				Object.values(INDEXED_DB_TABLES).forEach((storeName) => {
					if (!db.objectStoreNames.contains(storeName)) {
						db.createObjectStore(storeName, { keyPath: "id" });
					}
				});
			};
		});
	}

	return dbPromise;
}

export async function getCache(storeName) {
	try {
		const db = await openDB();
		const store = db.transaction(storeName, "readonly").objectStore(storeName);
		return new Promise((resolve, reject) => {
			const request = store.getAll();
			request.onerror = () => reject(request.error);
			request.onsuccess = () => resolve(request.result);
		});
	} catch (e) {
		console.error(`IndexedDB get error (${storeName})`, e);
		return null;
	}
}

export async function setCache(storeName, value) {
	try {
		const db = await openDB();
		const store = db.transaction(storeName, "readwrite").objectStore(storeName);
		return new Promise((resolve, reject) => {
			const request = store.put(value);
			request.onerror = () => reject(request.error);
			request.onsuccess = () => resolve(request.result);
		});
	} catch (e) {
		console.error(`IndexedDB set error (${storeName})`, e);
	}
}

export async function setCacheMultiple(storeName, values) {
	return Promise.all(values.map((value) => setCache(storeName, value)));
}

export function initCacheTimestamp() {
	try {
		localStorage.setItem("init_data_timestamp", Date.now().toString());
	} catch (e) {
		console.error("Error saving init timestamp to localStorage", e);
	}
}

export function getInitCacheTimestamp() {
	const now = Date.now();
	const timestamp = localStorage.getItem("init_data_timestamp");

	if (!timestamp) {
		localStorage.setItem("init_data_timestamp", now.toString());
	}

	return +timestamp || now;
}

export async function clearStore(storeName) {
	try {
		const db = await openDB();
		const store = db.transaction(storeName, "readwrite").objectStore(storeName);
		return new Promise((resolve, reject) => {
			const request = store.clear();
			request.onerror = () => reject(request.error);
			request.onsuccess = () => resolve(request.result);
		});
	} catch (e) {
		console.error(`IndexedDB clearStore error (${storeName})`, e);
	}
}

export async function deleteCache(storeName, key) {
	try {
		const db = await openDB();
		const store = db.transaction(storeName, "readwrite").objectStore(storeName);
		return new Promise((resolve, reject) => {
			const request = store.delete(key);
			request.onerror = () => reject(request.error);
			request.onsuccess = () => resolve(request.result);
		});
	} catch (e) {
		console.error(`IndexedDB delete error (${storeName})`, e);
	}
}
